<section class="contact-page">
  <div class="contact-shell container">
    <section class="contact-stage">
      <div class="contact-stage-backdrop"></div>
      <div class="contact-stage-overlay"></div>

      <div class="contact-stage-inner">
        <article class="contact-story">
          <p class="eyebrow">Contact Us</p>
          <h1>Let Us Map Your Next Development Move</h1>
          <p class="contact-lead">
            Share your goals and timelines. Our team will respond within one business day with a
            tailored roadmap.
          </p>

          <div class="contact-points">
            <div class="contact-point" *ngFor="let channel of channels">
              <span class="contact-point-icon" aria-hidden="true"></span>
              <div class="contact-point-copy">
                <p class="contact-point-label">{{ channel.label }}</p>
                <p class="contact-point-value">{{ channel.value }}</p>
              </div>
            </div>
          </div>
        </article>

        <aside class="contact-form-card">
          <form class="contact-form" #contactForm="ngForm" (ngSubmit)="submitForm()">
            <label>
              Full Name
              <input
                type="text"
                placeholder="Name"
                [(ngModel)]="fullName"
                name="fullName"
                required
                #fullNameModel="ngModel"
              />
              <div *ngIf="fullNameModel.invalid && (fullNameModel.touched || contactForm.submitted)" class="error">Full Name is required.</div>
            </label>

            <div class="form-field">
              <span class="field-label">Subject</span>
              <div class="custom-dropdown" [class.open]="isDropdownOpen" #subjectDropdown>
                <button type="button" class="dropdown-toggle" (click)="toggleDropdown(); $event.stopPropagation()" [attr.aria-expanded]="isDropdownOpen">
                  {{ subject || 'Select a subject' }}
                  <span class="dropdown-arrow" [class.rotated]="isDropdownOpen">&#9660;</span>
                </button>
                <ul class="dropdown-menu" *ngIf="isDropdownOpen">
                  <li *ngFor="let subj of subjects" (mousedown)="$event.preventDefault()" (click)="selectSubject(subj); $event.stopPropagation()" class="dropdown-item">
                    {{ subj }}
                  </li>
                </ul>
              </div>
              <input type="hidden" [(ngModel)]="subject" name="subject" required #subjectModel="ngModel" />
              <div *ngIf="subjectModel.invalid && (subjectModel.touched || contactForm.submitted)" class="error">Please select a subject.</div>
            </div>

            <label>
              Email
              <input type="email" placeholder="Email" [(ngModel)]="email" name="email" required pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" #emailModel="ngModel" />
              <div *ngIf="emailModel.invalid && (emailModel.touched || contactForm.submitted)" class="error">Please enter a valid email address.</div>
            </label>

            <label>
              Project Summary
              <textarea rows="4" placeholder="Summary" [(ngModel)]="projectSummary" name="projectSummary" required #projectSummaryModel="ngModel"></textarea>
              <div *ngIf="projectSummaryModel.invalid && (projectSummaryModel.touched || contactForm.submitted)" class="error">Project Summary is required.</div>
            </label>

            <p *ngIf="successMessage" class="form-status success">{{ successMessage }}</p>
            <p *ngIf="errorMessage" class="form-status error">{{ errorMessage }}</p>

            <button class="btn-primary" type="submit" [disabled]="isSubmitting || contactForm.invalid">
              {{ isSubmitting ? 'Sending...' : 'Connect' }}
            </button>
          </form>
        </aside>
      </div>
    </section>
  </div>
</section>
